import React, { useState } from 'react';
import {
  Box,
  Typography,
  Container,
  Dialog,
  IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import Slider, { Settings } from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import SmoothWaveText from '../../../../Components/SmoothWaveText';

const SlickSlider = Slider as unknown as React.FC<any>;

type SlideItem = {
  id: string;
  title: string;
  image: string;
};

const slides: SlideItem[] = [
  {
    id: '1',
    title: '',
    image: 'https://dprstorage.b-cdn.net/RW/exhibit3.png',
  },
  {
    id: '2',
    title: '',
    image: 'https://dprstorage.b-cdn.net/RW/Mentorin1.jpg',
  },
  {
    id: '3',
    title: '',
    image: 'https://dprstorage.b-cdn.net/RW/salesprograminner.png',
  },
  {
    id: '4',
    title: '',
    image: 'https://dprstorage.b-cdn.net/RW/Mentoring2.jpg',
  },
];

const UltraLuxuryHeroSlider: React.FC = () => {
  const [activeImage, setActiveImage] = useState<string | null>(null);

  const settings: Settings = {
    dots: true,
    arrows: false,
    infinite: true,
    speed: 1100,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5200,
    cssEase: 'cubic-bezier(0.22, 1, 0.36, 1)',
  };

  return (
    <>
      <Box py={{ xs: 8, md: 8 }}>
        <Container maxWidth="xl">
          <Box
            sx={{
              borderRadius: '22px',
              overflow: 'visible',
              transform: 'perspective(1400px)',
              /* 🔵 LUXURY DOTS */
              '& .slick-dots': {
                bottom: '-42px',
              },
              '& .slick-dots li': {
                margin: '0 6px',
              },
              '& .slick-dots li button:before': {
                fontSize: '10px',
                color: '#000',
                opacity: 0.35,
              },
              '& .slick-dots li.slick-active button:before': {
                opacity: 1,
                color: '#000',
              },
            }}
          >
            <SmoothWaveText
              variant="h4"
              sx={{ fontSize: 36, mb: 2, textAlign: 'start', fontWeight: 700 ,color:'#fff'}}
            >
              Sales Coaching for Competitive Real Estate Markets
            </SmoothWaveText>
          <Box id="text" sx={{ mb: 3 ,}}>
            <Typography variant="body2" sx={{ textAlign: 'start',color:'#fff' }}>
              We work with real estate professionals and builder sales teams who want control over their sales conversations, not just more activity
            </Typography>
            <Typography variant="body2" sx={{ textAlign: 'start', mt: 2 ,color:'#fff'}}>
              This coaching focuses on how deals actually move forward, from the first conversation to the final close, especially in premium and ultra-competitive markets.
            </Typography>
          </Box>
          
            <SlickSlider {...settings}>
              {slides.map((slide) => (
                <Box
                  key={slide.id}
                  sx={{
                    position: 'relative',
                    height: { xs: 440, md: 520 },
                    borderRadius: '22px',
                    overflow: 'hidden',
                    transform: 'translateZ(0)',
                  }}
                >
                  {/* IMAGE */}
                  <Box
                    component="img"
                    src={slide.image}
                    alt={slide.title}
                    onClick={() => setActiveImage(slide.image)}
                    sx={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                      cursor: 'pointer',
                      filter: 'brightness(0.95)',
                    }}
                  />

                  {/* FEATHERED LUXURY PANEL */}
                  <Box
                    sx={{
                      position: 'absolute',
                      inset: 0,
                      borderRadius: '22px',
                      background: `
                        linear-gradient(90deg, rgb(79 105 127 / 97%) 0%, rgb(48 57 65 / 92%) 14%, rgb(44 118 171 / 55%) 32%, rgba(21, 71, 111, 0.18) 48%, rgba(21, 71, 111, 0.02) 60%, rgb(41 59 81 / 0%) 70%)
                      `,
                      display: 'flex',
                      alignItems: 'center',
                      px: { xs: 3, md: 5 },
                      pointerEvents: 'none',
                    }}
                  >
                    <Box>
                      <Typography
                        sx={{
                          fontSize: { xs: 30, md: 48 },
                          fontWeight: 700,
                          color: '#fff',
                          lineHeight: 1.1,
                        }}
                      >
                        {slide.title}
                      </Typography>

                      {/* <Typography
                        sx={{
                          mt: 2,
                          fontSize: { xs: 14, md: 17 },
                          color: '#475569',
                        }}
                      >
                        {slide.subtitle}
                      </Typography> */}

                      {/* <Box
                        sx={{
                          mt: 1,
                          width: 64,
                          height: 3,
                          backgroundColor: '#0f63a5',
                          borderRadius: 3,
                        }}
                      /> */}
                    </Box>
                  </Box>
                </Box>
              ))}
            </SlickSlider>
          </Box>
        </Container>
      </Box>

      {/* POPUP */}
      <Dialog
        open={Boolean(activeImage)}
        onClose={() => setActiveImage(null)}
        maxWidth="lg"
        PaperProps={{
          sx: {
            background: 'transparent',
            boxShadow: 'none',
          },
        }}
        BackdropProps={{
          sx: {
            backgroundColor: 'rgba(0,0,0,0.85)',
          },
        }}
      >
        <IconButton
          onClick={() => setActiveImage(null)}
          sx={{
            position: 'absolute',
            top: 12,
            right: 12,
            zIndex: 10,
            color: '#fff',
            background: 'rgba(0,0,0,0.4)',
            '&:hover': { background: 'rgba(0,0,0,0.6)' },
          }}
        >
          <CloseIcon />
        </IconButton>

        {activeImage && (
          <Box
            component="img"
            src={activeImage}
            alt="Preview"
            sx={{
              maxHeight: '85vh',
              maxWidth: '90vw',
              objectFit: 'contain',
              borderRadius: '12px',
            }}
          />
        )}
      </Dialog>
    </>
  );
};

export default UltraLuxuryHeroSlider;
